import PropTypes from 'prop-types';
import { CROWN_BLACK } from '../../styles/brandAssets';
import { BORDER_RADIUS, COLORS } from '../../styles/UISystem';

/**
 * ExpiredChatScreen — what the Anon finds past the expiry window (social-track
 * decision #11, user-specced at refine): the thread is replaced by
 *   crown / "Royale" / "Your chat has expired" /
 *   "Get the app and keep your chats alive" / signup entry.
 *
 * The offer-to-forget promise, followed through — strictly the Anon's OWN
 * window; the Profile's record is untouched. WelcomePage grammar (crown +
 * wordmark + waitlist capture); the "field" is a tap target that opens the
 * existing LaunchSignupOverlay, which owns real collection + funnel logging.
 *
 * `held` variant (exchange-clarity D10/D12): after joining FROM this screen
 * the room shows "Your chat is waiting for you" — literally true (the
 * waitlist row ties the room; conversion restores it) — instead of a
 * silently-reopened dead chat. No signup entry; they already joined.
 */
const ExpiredChatScreen = ({ onJoin, held = false }) => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      padding: '0 32px calc(48px + env(safe-area-inset-bottom))',
      gap: '0',
    }}
  >
    <img src={CROWN_BLACK} alt="" style={{ width: '64px', height: '40px' }} />
    <h1
      style={{
        fontSize: '28px',
        fontWeight: '700',
        color: '#000000',
        marginTop: '20px',
        marginBottom: '0',
      }}
    >
      Royale
    </h1>
    <p
      style={{
        fontSize: '17px',
        fontWeight: 500,
        color: COLORS.CHAT_TEXT_DARK,
        marginTop: '28px',
        marginBottom: '0',
      }}
    >
      {held ? 'Your chat is waiting for you' : 'Your chat has expired'}
    </p>
    {/* Held: the promise needs its mechanism (user, 2026-07-27 — a kept chat
        with no timeline reads as a locked door). Expired: the get-the-app
        line + signup entry. One subtitle element, two texts. */}
    <p
      style={{
        fontSize: '15px',
        color: '#8E8E93',
        textAlign: 'center',
        lineHeight: 1.4,
        marginTop: '10px',
        marginBottom: held ? 0 : '32px',
      }}
    >
      {held ? 'Your invite is coming soon' : 'Get the app and keep your chats alive'}
    </p>
    {!held && (
      /* Signup entry — opens the waitlist overlay (real collection lives there) */
      <button
        onClick={onJoin}
        style={{
          width: '100%',
          maxWidth: '340px',
          minHeight: '50px',
          borderRadius: BORDER_RADIUS.PILL,
          border: `1px solid ${COLORS.MEDIUM_DARK_GRAY}`,
          backgroundColor: '#FFFFFF',
          fontSize: '17px',
          color: '#AEAEB2',
          textAlign: 'left',
          padding: '0 18px',
          cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        Your number or email
      </button>
    )}
  </div>
);

ExpiredChatScreen.propTypes = {
  onJoin: PropTypes.func,
  held: PropTypes.bool,
};

export default ExpiredChatScreen;
